import { render } from "./index.vue?vue&type=template&id=22ab6d3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=22ab6d3c&lang=less&scoped=true"

import exportComponent from "/home/runner/work/easticloud-admin/easticloud-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ab6d3c"]])

export default __exports__